//client/src/components/tiposContrato/TipoContratoRow.js
import React from 'react';
import { MoreVertical } from 'lucide-react';

const TipoContratoRow = ({ tipo, onOpenActions, loading }) => {
    return (
        <tr className="table-row-hover">
            <td className="td-name">{tipo.nome}</td>
            <td>
                <span className="badge badge-gray">{tipo.codigo}</span>
            </td>
            <td>{tipo.descricao || '-'}</td>
            <td className="text-right">
                <button onClick={() => onOpenActions(tipo)} title="Ações" className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={loading}>
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

export default TipoContratoRow;